import { CheckoutDiscountProfileAttributes } from './checkout-discount-profile-attributes.interface';

export interface CheckoutDiscountProfileAttributesAch
  extends CheckoutDiscountProfileAttributes {
  achDiscountCodeApplied: string;
}
